import axios from 'axios';
import moment from 'moment';
import ProfilePassport from '../profilePassport/ProfilePassport.vue';

const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default {
  components: { ProfilePassport },
  data() {
    return {
      valid: false,
      profile: {},
      rules: {
        required: value => !!value || 'Поле должно быть заполнено',
        email: value => pattern.test(value) || 'Поле E-mail заполнено с ошибками',
        phone: v => (!!v && (!v.length || v.length >= 17)) || 'Номер телефона заполнен не полностью',
      },
      search: '',
      suggestions: [],
      suggestions_items: [],
      menu2: '',
      salesPointLegalName: null,
      salesPointFactName: null,
      salesPointAddress: null,
      cityName: null,
      maxDate: moment().subtract(18, 'years'),
      birthday_on: null,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    loading() {
      return this.$store.state.loading;
    },
    settings() {
      return this.$store.state.settings;
    },
  },
  methods: {
    parseDate(date) {
      if (!date) return null;
      const [d, m, y] = date.split('.');
      return `${y}-${m}-${d}`;
    },
    AutocompleteSelect(item) {
      this.suggestions.forEach((sug) => {
        if (sug.value === item.value) {
          this.address_data = sug.data;
          document.getElementById('ndfl-form-address').focus();
        }
      });
    },
    AutocompleteSearch(queryString, cb) {
      if (!queryString) return;
      const app = this;
      const info = { count: 20, query: queryString };
      const config = {
        headers: {
          Accept: 'application/json, text/javascript, */*; q=0.01',
          Authorization: 'Token 7a77efb8ab6dae6e380c7e438b85360185660f34',
          'Content-Type': 'application/json',
        },
      };

      axios.post('https://dadata.ru/api/v2/suggest/address', info, config)
        .then((res) => {
          app.suggestions = res.data.suggestions;
          cb(app.suggestions);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    createUser() {
      this.profile = { ...this.user };
      this.salesPointFactName = this.user?.salesPointFactName?.name;
      this.salesPointLegalName = this.user?.salesPointLegalName?.name;
      this.salesPointAddress = this.user?.salesPointAddress?.name;
      this.cityName = this.user?.city?.title;


      if (this.profile?.birthday_on) {
        this.birthday_on = this.parseDate(this.profile?.birthday_on);
      }
    },
    profileSubmit() {
      const app = this;
      if (this.$refs.form.validate() && this.isAuthenticated) {
        const profile = {
          profile_id: app.profile.profile_id,
          birthday_on_local: app.profile.birthday_on_local,
          gender: app.profile.gender,
          address: app.profile.address,
          phone_mobile_local: app.profile.phone_mobile,
          phone_local: app.profile.phone,
          email: app.profile.email,
        };
        app.$store.getters.axl.post('profiles/api/auth/profile-edit', profile)
          .then(() => {
            app.$store.dispatch('ShowInfo', 'Ваш профиль был успешно обновлён');
            this.$router.push({ name: 'dashboard' });
          })
          .catch((error) => {
            app.$store.dispatch('HandleError', error);
          });
      } else {
        app.$store.dispatch('HandleError', 'Ошибка отправки формы');
      }
    },
  },
  watch: {
    birthday_on(val) {
      if (val) {
        const date = new Date(val);
        this.birthday_on_local = date.toLocaleDateString();
      }
    },
  },
  mounted() {
    if (this.isAuthenticated) {
      this.$store.dispatch('eps/GetOrders', this.user.profile_id);
      this.createUser();
    }
  },
};
